export default __webpack_public_path__ + "static/media/01.d7c7f9d6.jpg";